import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IGetNoticeResponse } from "../../types/GetNoticesRes";

const initialState: IGetNoticeResponse = {
  orgunit: "",
  bookingNumber: "",
  bookingUsername: "",
  orderId: "",
  isUsernameCorrect: false,
  isExpired: false,
  isCanceled: false,
  notices: [],
};

const noticeSlice = createSlice({
  name: "notices",
  initialState,
  reducers: {
    setNotices: (state, action) => {
      return action.payload;
    },
  },
});

export const noticeActions = noticeSlice.actions;

export default noticeSlice;
